module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "id": "map",
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1680.663929863537!2d30.32415810007848!3d59.93782520306914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4696310e548083db%3A0x2b4270236080aca6!2z0JzQsNC70LDRjyDQmtC-0L3RjtGI0LXQvdC90LDRjyDRg9C7LiwgMSwg0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LMsIDE5MTE4Ng!5e0!3m2!1sru!2sru!4v1500893477781",
      "frameborder": "0",
      "height": _vm.height,
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 centered"
  }, [_c('p'), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+78129161500"
    }
  }, [_vm._v("Телефон: +7 (812) 916-15-00")])]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86672b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts.vue
// module id = 239
// module chunks = 1